var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "forward-department" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c(
          "a-button",
          {
            staticClass: "back-button",
            on: {
              click: function ($event) {
                return _vm.$emit("back")
              },
            },
          },
          [_c("a-icon", { attrs: { type: "arrow-left" } })],
          1
        ),
        _vm._v(" "),
        _c("h3", [_vm._v(_vm._s(_vm.$t("message.selectDepartmentToForward")))]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "explanation" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$t("message.selectDepartmentToForwardAgent", {
              selectAgentName: _vm.selectedAgentName,
            })
          ) +
          "\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search-input" },
      [
        _c("a-input-search", {
          attrs: { placeholder: _vm.$t("message.searchDepartment") },
          on: { search: _vm.onSearch },
          model: {
            value: _vm.searchText,
            callback: function ($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "department-list" }, [
      _c(
        "div",
        { staticClass: "department-grid" },
        _vm._l(_vm.filteredDepartments, function (department) {
          return _c(
            "div",
            {
              key: department._id,
              staticClass: "department-item",
              class: {
                "department-item--disabled": !_vm.isDepartmentValid(department),
                "department-item--current":
                  department._id === _vm.defaultSelectedDepartment,
              },
            },
            [
              _c(
                "div",
                { staticClass: "department-name" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.getDepartmentName(department)) +
                      "\n                    "
                  ),
                  _c("a-badge", {
                    attrs: {
                      status: "processing",
                      text: _vm.$t("message.currentDepartment"),
                    },
                  }),
                  _vm._v(" "),
                  _c("a-badge", {
                    attrs: {
                      status: "success",
                      text: _vm.$t("message.validDepartment"),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "department-actions" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: {
                        ghost: "",
                        primary: "",
                        disabled: !_vm.isDepartmentValid(department),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.forwardToDepartment(department._id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.changeDepartmentAndForward")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isDepartmentValid(department)
                ? _c(
                    "div",
                    { staticClass: "invalid-reason" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getInvalidReason(department)) +
                          "\n                    "
                      ),
                      _c(
                        "a-button",
                        {
                          staticClass: "settings-link",
                          attrs: { type: "link" },
                          on: {
                            click: function ($event) {
                              return _vm.navigateToSettings(department)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.goToSettings")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "valid-reason" }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.youCanForwardToThisDepartment"))
                    ),
                  ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }